import React from "react";
import videojs from "video.js";
import VideoJS from "./Video";

/**
 *
 * @param {{training: import("../../hooks/type").Training}} params
 * @returns
 */
function VideoContainer({ training }) {
  const playerRef = React.useRef(null);

  const sections = training?.sections;
  const videos = sections?.flatMap((section) => section.videos);

  const videoJsOptions = {
    autoplay: false,
    controls: true,
    responsive: true,
    fluid: true,
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    player.on("waiting", () => {
      videojs.log("player is waiting");
    });

    player.on("dispose", () => {
      videojs.log("player will dispose");
    });
  };

  const playVideo = (src) => {
    const player = playerRef.current;

    if (player) {
      player.src(src);
      player.on('canplay', () => {
        player.play();
        player.off('canplay');
      });
    }
  };

  return (
    <div className="container mx-auto p-4">
      <VideoJS
        options={videoJsOptions}
        onReady={handlePlayerReady}
        playVideo={playVideo}
        videos={videos}
        training={training}
      />
    </div>
  );
}

export default VideoContainer;
